import { useCallback, useState } from 'react'

import { Contact } from '@features/contacts/types/contact'

import { useUpdateContactWithExternalId } from './useUpdateContactWithExternalId'

interface UseFetchDefaultContactProps {
  contactId?: string
  enabled: boolean
}

export const useFetchDefaultContact = ({ contactId, enabled }: UseFetchDefaultContactProps) => {
  const [defaultContact, setDefaultContact] = useState<Contact | undefined>(undefined)

  const onContactUpdate = useCallback((contact: Contact) => {
    setDefaultContact(contact)
  }, [])

  const { isProcessing } = useUpdateContactWithExternalId({
    contactId,
    onContactUpdate,
    enabled: enabled && !defaultContact,
  })

  return {
    contact: defaultContact,
    isLoading: isProcessing,
  }
}
